import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faMinus,
  faPlus,
  faCaretDown,
  faAngleLeft,
  faAngleRight,
  faEye,
  faEyeSlash,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faFolderTree,
  faList,
  faSort,
  faCheck,
  faXmark,
  faCircleHalfStroke,
  faMagnifyingGlass,
  faUser,
  faShapes,
  faScroll,
  faLaptop,
  faPen,
  faEquals,
  faNotEqual,
  faRecycle,
  faRepeat,
  faGear,
  faClockRotateLeft,
  faFaceSmile,
  faFaceMeh,
  faArrowsLeftRight,
  faGreaterThan,
  faLessThan,
  faGreaterThanEqual,
  faLessThanEqual,
} from "@fortawesome/free-solid-svg-icons";

// fa
library.add(
  faMinus,
  faPlus,
  faCaretDown,
  faAngleLeft,
  faAngleRight,
  faEye,
  faEyeSlash,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faFolderTree,
  faList,
  faSort,
  faCheck,
  faXmark,
  faCircleHalfStroke,
  faMagnifyingGlass,
  faUser,
  faShapes,
  faScroll,
  faLaptop,
  faPen,
  faEquals,
  faNotEqual,
  faRecycle,
  faRepeat,
  faGear,
  faClockRotateLeft,
  faFaceSmile,
  faFaceMeh,
  faArrowsLeftRight,
  faGreaterThan,
  faLessThan,
  faGreaterThanEqual,
  faLessThanEqual
);

export { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
